import { useEffect } from "react";
import { useStore } from "src/stores/Store";

interface Props {
  time: number;
  onEnd: () => void;
}

export function Timer(props: Props) {
  const store = useStore();

  useEffect(() => {
    document.querySelector("#timer").addEventListener("animationend", (e) => {
      props.onEnd();

      const target = e.target as HTMLElement;
      target.classList.add("w-full");
    });
  }, []);

  return (
    <div className="mx-auto h-1.5 w-48 overflow-hidden rounded-lg bg-borderGray">
      <div
        className="h-1.5 origin-left transition-all"
        id="timer"
        css={{
          background: store.theme.orgColor,
          animation: `timer ${props.time}ms ease-out 1`,
        }}
      />
    </div>
  );
}
